import {
  Input,
  Inject,
  OnInit,
  Output,
  Component,
  EventEmitter,
} from 'ng-metadata/core';

import { DialogService } from 'services/dialog.service';
import { AuthService, UserInterface } from 'services/auth.service';

import authenticationHtml from './authentication.html';
import './authentication.scss';



/**
 * User Authentication toggle and off-canvas panel
 */
@Component({
  selector: 'gwAuthentication',
  template: authenticationHtml,
})
export class AuthenticationComponent implements OnInit {
  public state = {
    error: null,
    mode: 'login',
    submitting: false,
    forgotPasswordUrl: `${process.env.MIX_MYGOVWORKS}/#!/forgot`,
  };

  public user = {
    email: '',
    password: '',
  };

  @Output() onFinish = new EventEmitter();

  constructor(
    @Inject('$timeout') private $timeout: ng.ITimeoutService,
    @Inject(AuthService) private authService: AuthService,
  ) {}

  ngOnInit() {
  }

  formSubmit() {
    switch (this.state.mode) {
      case 'login':
        this.userLogin();
        break;
    }
  }

  /**
   * Login Request
   */
  async userLogin() {
    this.state.submitting = true;

    try {
      const user: UserInterface = await this.authService.loginUser(this.user);
      if (user.loggedIn) this.onFinish.emit({ reload: true });
    } catch (e) {
      this.handleError(e);
      this.$timeout(() => this.state.submitting = false, 2000);
    }
  }

  handleError(exception: any = {}) {
    let message;

    if (!exception) {
      return;
    }

    switch (exception.status_code) {
      case 403:
        message = 'The email address or password you entered is incorrect.';
        break;

      case 500:
        message = 'Too many frequent failed attempts. Please try again later.';
        break;

      default:
        message = null;
    }

    this.state.error = message;
    this.$timeout(() => this.state.error = null, 2000);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/authentication/authentication.component.ts